import React, { useCallback, useState } from 'react';

import styled, { css } from 'styled-components';

import AuthModal from '@/components/AuthModal';
import Button from '@/components/Button';
import { useAuth } from '@/contexts/auth';
import { api } from '@/services/api';
import { showAlert } from '@/utils';

type Props = {
  eventId: number;
};

const Wrapper = styled.div`
  ${() => css`
    button {
      width: 100%;
    }
  `}
`;

const PreSale: React.FC<Props> = ({ eventId }) => {
  const { isAuthenticated, clientData } = useAuth();
  const [loading, setLoading] = useState(false);
  const [openModalAuth, setOpenModalAuth] = useState(false);

  const handlePreSale = useCallback(async () => {
    if (!isAuthenticated) {
      setOpenModalAuth(true);

      return;
    }

    try {
      setLoading(true);

      await api.post(`/v1/web/events/pre-sale`, {
        eventId,
        clientId: clientData.codCliente,
      });

      showAlert('Reserva efetuada com sucesso.');
    } finally {
      setLoading(false);
    }
  }, [clientData, eventId, isAuthenticated]);

  return (
    <>
      <Wrapper>
        <Button type="button" disabled={loading} onClick={handlePreSale}>
          {loading ? 'Reservando...' : 'Reservar ingresso'}
        </Button>
      </Wrapper>

      <AuthModal open={openModalAuth} onClose={() => setOpenModalAuth(false)} />
    </>
  );
};

export default React.memo(PreSale);
